define.alias("shared/components/shared/media-library", "settings/components/shared/media-library");